module.exports = __webpack_public_path__ + "assets/OWA.1f8c48e8.svg";